/** @format */
import { css } from 'styled-components';

import { StyledIntercomProps } from './index';
import { getBottom, getDisplay } from './style-helpers';

/**
 * Base styles for the intercom component
 *
 * @param {StyledIntercomProps} props The intercom properties object
 * */
const baseStyles = ({
    stickyFooterHeight,
    shouldDisplayCustomLauncher,
}: StyledIntercomProps) => css`
    display: ${getDisplay(shouldDisplayCustomLauncher)};
    align-items: center;
    justify-content: center;
    width: 6rem;
    height: 6rem;
    position: fixed;
    right: var(--layout-spacing-24);
    bottom: ${getBottom(stickyFooterHeight)};
    background: var(--colors-surface-inverse);
    border-radius: 50%;
    border: none;
    cursor: pointer;
    z-index: var(--z-index-intercom);

    svg {
        width: 2.8rem;
        height: 3.2rem;
        fill: var(--colors-text-inverse);
    }
`;

/**
 * The intercom component styles
 *
 * @param {StyledIntercomProps} props The intercom properties object
 * */
export const styles = (props: StyledIntercomProps) => css`
    ${baseStyles(props)}
`;
